export default __webpack_public_path__ + "static/media/streetmeat.b6666d56.png";